<template>
  <div>
    <div>
      <van-area title="地区选择" :area-list="areaList" @confirm="confirm" @cancel="cancel"/>
    </div>
  </div>
</template>

<script type="text/javascript">
import areaData from './areaData'
export default {
  data() {
    return {
      areaList:areaData
    }
  },
  methods:{
    confirm(e){
      this.$emit('onSuccess',e)
    },
    cancel(e){
      this.$emit('onConse',e)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
